export default __webpack_public_path__ + "static/media/UR.2col.v1.rev.51cab7ef.png";